module.exports = __webpack_public_path__ + "static/media/setting-secure.2b7e5746.png";